// Reads another dashboard's title (DASHBOARD_NAME) for the drill-through
// chooser. Uses the render read `load-dashboard-object`, which the Run view
// may call too, so it works for project users as well as builders.

import { loadDashboardObject } from '@/api/designers'

export function dashboardTitleLoader(project: string) {
  return async (obj: string): Promise<string | undefined> => {
    if (!project || !obj) return undefined
    const res = await loadDashboardObject(project, obj)
    const c = (res?.content ?? null) as Record<string, unknown> | null
    if (!c || typeof c !== 'object') return undefined
    const body = (c.DASHBOARD && typeof c.DASHBOARD === 'object' ? c.DASHBOARD : c) as Record<string, unknown>
    return typeof body.DASHBOARD_NAME === 'string' ? body.DASHBOARD_NAME : undefined
  }
}
